import { render, staticRenderFns } from "./ThumbsColorUpReview.vue?vue&type=template&id=3c83bb12&scoped=true&"
import script from "./ThumbsColorUpReview.vue?vue&type=script&lang=js&"
export * from "./ThumbsColorUpReview.vue?vue&type=script&lang=js&"
import style0 from "./ThumbsColorUpReview.vue?vue&type=style&index=0&id=3c83bb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83bb12",
  null
  
)

export default component.exports